<template>
   <div class="topContainer">
      <div class="pageHeader">Partners</div>
      <div class="sectionInfo">
       <div class="sectionHeader">
       </div>
       <div class="sectionContent">
        <b-list-group horizontal="md">
         <b-list-group-item v-for="partner in partnerList.primary" :key="partner.title">
            <div class="sectionHeaderSm" >
               <a :href="partner.url" target="_blank" rel="noopener noreferrer">{{ partner.title}}</a>
            </div>
            <img :src="require('@/assets/'+ partner.img)" class="imgSize"/>
         </b-list-group-item>         
        </b-list-group>
        <div class='list-group-item' v-for="other in partnerList.other" :key="other">
           {{ other }}
        </div>
      </div>
    </div>
   </div>
</template>
<script>
import {PartnerList} from '../partnerList.js';

export default {
  data: function () {
     return {    
         partnerList: PartnerList
     }
  }
}
</script>
<style scoped>
.topContainer{
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~@/assets/aacc.jpg') no-repeat center center fixed;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
     background-size: cover;
    height: 60px;
    width: 100%;
    position: relative;
    z-index: 2;
    border-bottom: 2px solid black;
    box-shadow: 1px 1px #111;
}
.imgSize {
   height: 200px;
   margin: 5px 5px;
}
.sectionHeaderSm{
   font-size:1.2em;
   font-weight: bold;
   text-align: center;
}
.list-group{ 
  flex-wrap: wrap;
}
.list-group-item {
  padding: 10px;
  margin:10px;
}
.sectionContent{
  margin-top:0px;
}
</style>
